import {get, post, postJson} from './axios'

// 会员营销-会员分群
const RESOURCE_BASE_PATH = '/memberCrowd'

// 新增/编辑人群
export const addMemberCrowd = p => postJson(`${RESOURCE_BASE_PATH}/`, p);

// 人群交并差计算（用于精准营销中的计算人群）
export const packStatus = p => get(`${RESOURCE_BASE_PATH}/pack-status`, p);

//获取显示试用高级版标记权限集合
export const advancedTags = p => get(`/seller/get/advanced-tags/list`, p);

// 获取最近常用标签列表
export const getLastUsed = p => get(`${RESOURCE_BASE_PATH}/lastUsed`, p);

// 获取自定义常用标签列表
export const getLastUsedCustom = p => get(`${RESOURCE_BASE_PATH}/lastUsed/custom`, p);

// 设置为自定义常用标签
export const lastUsedSave = p => postJson(`${RESOURCE_BASE_PATH}/lastUsed/custom/save`, p);

// 取消自定义常用标签
export const lastUsedDelete = p => postJson(`${RESOURCE_BASE_PATH}/lastUsed/custom/delete`, p);
